/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const color = {
  primitive: {
    black: '#000000',
    blue: {
      '10': '#f5f8ff',
      '20': '#e0ebfe',
      '30': '#8fb6fc',
      '40': '#3e80fa',
      '50': '#0158f9',
      '60': '#0143bd',
      '70': '#012e82',
      '80': '#001c50',
      '90': '#00030a',
    },
    darkBlue: {
      '10': '#f8f8fa',
      '20': '#e9e9f0',
      '30': '#afafc9',
      '40': '#7474a2',
      '50': '#484885',
      '60': '#373765',
      '70': '#262645',
      '80': '#17172b',
      '90': '#0e0d24',
    },
    darkBlueChannel: {
      '10': '248 248 250',
      '20': '233 233 240',
      '30': '175 175 201',
      '40': '116 116 162',
      '50': '72 72 133',
      '60': '55 55 101',
      '70': '38 38 69',
      '80': '23 23 43',
      '90': '14 13 36',
    },
    green: {
      '10': '#f6faf7',
      '20': '#e3efe7',
      '30': '#9bc4a7',
      '40': '#529966',
      '50': '#1b7936',
      '60': '#155c29',
      '70': '#0e3f1c',
      '80': '#092711',
      '90': '#010502',
    },
    grey: {
      '10': '#fafafb',
      '20': '#f0f0f2',
      '30': '#c9c9d1',
      '40': '#a2a2af',
      '50': '#858596',
      '60': '#656572',
      '70': '#45454e',
      '80': '#2b2b30',
      '90': '#050506',
    },
    orange: {
      '10': '#fcf8f5',
      '20': '#f7eae0',
      '30': '#e2b28f',
      '40': '#cd793d',
      '50': '#bd4f00',
      '60': '#903c00',
      '70': '#632900',
      '80': '#3d1900',
      '90': '#070300',
    },
    pink: {
      '10': '#fcf6fa',
      '20': '#f6e6f1',
      '30': '#da98c6',
      '40': '#be4c9c',
      '50': '#aa147d',
      '60': '#810f5f',
      '70': '#590a41',
      '80': '#370628',
      '90': '#070105',
    },
    purple: {
      '10': '#faf7fb',
      '20': '#efe7f2',
      '30': '#c4a7ce',
      '40': '#9966ab',
      '50': '#793690',
      '60': '#5c296e',
      '70': '#3f1c4b',
      '80': '#27112e',
      '90': '#050206',
    },
    red: {
      '10': '#fdf6f6',
      '20': '#f9e3e4',
      '30': '#e99b9f',
      '40': '#db575d',
      '50': '#ce1c25',
      '60': '#9d151c',
      '70': '#6b0f13',
      '80': '#42090c',
      '90': '#080101',
    },
    transparent: {
      darkBlue: {
        'darkBlue-90-o-16': '#0e0d2429',
        'darkBlue-10-o-16': '#f8f8fa29',
        'darkBlue-90-o-4': '#0e0d240a',
        'darkBlue-10-o-4': '#f8f8fa0a',
        'darkBlue-90-o-8': '#0e0d2414',
        'darkBlue-10-o-8': '#f8f8fa14',
        'darkBlue-90-o-12': '#0e0d241f',
        'darkBlue-10-o-12': '#f8f8fa1f',
        'darkBlue-90-o-20': '#0e0d2433',
        'darkBlue-10-o-20': '#f8f8fa33',
        'darkBlue-90-o-1': '#0e0d2403',
        'darkBlue-10-o-1': '#f8f8fa03',
        'darkBlue-30-o-32': '#afafc952',
        'darkBlue-70-o-40': '#26264566',
        'darkBlue-30-o-56': '#afafc98f',
        'darkBlue-70-o-80': '#262645cc',
      },
      black: {
        'black-o-32': '#00000052',
        'black-o-16': '#00000029',
      },
      white: {
        'white-o-32': '#ffffff52',
        'white-o-16': '#ffffff29',
      },
      green: {
        'green-50-o-4': '#1b79360a',
        'green-50-o-6': '#1b79360f',
      },
      red: {
        'red-50-o-4': '#ce1c250a',
        'red-50-o-6': '#ce1c250f',
      },
      blue: {
        'blue-50-o-4': '#0158f90a',
        'blue-50-o-6': '#0158f90f',
      },
    },
    white: '#ffffff',
  },
} as const;

export const colorPrimitive = color.primitive;
